<template>
  <div class="menu">
    <section class="interior" :class="{'open': this.open}">
      <div class="links-wrapper">
        <div class="main-links">
          <img class="background-filter" src="@/assets/textura-elvas-branco@3x.png"/>
          <ol class="links">
            <li><router-link :to="{name: 'patrimonio'}">Património</router-link></li>
            <li><router-link :to="{name: 'pontos_de_interesse'}">Pontos de Interesse</router-link></li>
            <li><router-link :to="{name: 'eventos_e_atividade'}">Eventos & Actividades</router-link></li>
            <li><router-link :to="{name: 'percursos'}">Percursos</router-link></li>
            <li><router-link :to="{name: 'informacao_geral'}">Informação Geral</router-link></li>
            <li>
              <ol class="small-links">
                <li><router-link to="/estalagem">Hótel D. Sancho II</router-link></li>
                <li><router-link to="/estalagem">Restaurante o Dourado</router-link></li>
              </ol>
            </li>
          </ol>
        </div>
        <ol class="sub-links">
          <div>
            <section class="login-register">
              <h4>ÁREA RESERVADA</h4>
              <div v-if="!$store.state.user">
                <router-link to="/user/register"><elvas-button :button="{title: 'criar conta'}"></elvas-button></router-link>
                <router-link to="/user/login"><elvas-button class="no-filled" :button="{title: 'ENTRAR'}"></elvas-button></router-link>
              </div>
              <div v-else>
                <router-link to="/user/dashboard/informacao-pessoal" v-if="!$store.state.user.is_admin"><elvas-button :button="{title: 'ACEDER À CONTA'}"></elvas-button></router-link>
                <router-link to="/admin/interestPoints" v-else><elvas-button :button="{title: 'ACEDER DASHBOARD'}"></elvas-button></router-link>
              </div>
            </section>
            <section class="siga-nos">
              <h4>Siga-nos</h4>
              <div>
                <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26">
                  <g fill="none" fill-rule="evenodd">
                    <path d="M0 0H34V34H0z" transform="translate(-4 -4)"/>
                    <path fill="#f6b92f" d="M28.333 4.25H5.667c-.85 0-1.417.567-1.417 1.417v22.666c0 .709.567 1.417 1.417 1.417H17.85v-9.917h-3.258v-3.825h3.258v-2.833c0-3.258 1.983-5.1 4.958-5.1 1.417 0 2.55.142 2.975.142v3.4H23.8c-1.558 0-1.842.708-1.842 1.841v2.409h3.825l-.566 3.966h-3.259v9.917h6.375c.709 0 1.417-.567 1.417-1.417V5.667c0-.85-.567-1.417-1.417-1.417z" transform="translate(-4 -4)"/>
                  </g>
                </svg>
                <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26">
                  <g fill="none" fill-rule="evenodd">
                    <path d="M0 0H34V34H0z" transform="translate(-4 -4)"/>
                    <path fill="#f6b92f" d="M18.48 4.25c2.129.004 2.7.024 3.762.142 1.416 0 2.266.283 3.116.566.85.284 1.559.709 2.267 1.417.708.708 1.133 1.417 1.417 2.267.283.85.566 1.7.566 3.116.142 1.275.142 1.842.142 5.242s-.142 3.825-.142 5.242c0 1.416-.283 2.266-.566 3.116-.284.85-.709 1.559-1.417 2.267-.708.708-1.417 1.133-2.267 1.417-.85.283-1.7.566-3.116.566-1.275.142-1.842.142-5.242.142s-3.825 0-5.242-.142c-1.416 0-2.266-.283-3.116-.566-.85-.284-1.559-.709-2.267-1.417-.708-.708-1.133-1.417-1.417-2.267-.283-.85-.566-1.7-.566-3.116-.118-1.063-.138-1.633-.141-3.762v-2.96c.003-2.129.023-2.7.14-3.762 0-1.416.284-2.266.567-3.116.284-.85.709-1.559 1.417-2.267.708-.708 1.417-1.133 2.267-1.558.85-.284 1.7-.567 3.116-.567zm-.304 2.267h-2.352c-2.348.002-2.814.018-3.924.141-1.275 0-1.983.284-2.408.425-.567.142-.992.425-1.417.992-.425.425-.708.85-.992 1.417-.141.425-.425 1.133-.425 2.408-.123 1.11-.139 1.576-.141 3.924V17c0 3.4.141 3.825.141 5.1 0 1.275.284 1.983.425 2.408.284.567.567.992.992 1.417.425.425.85.708 1.417.992.425.141 1.133.425 2.408.425 1.11.123 1.576.139 3.924.141H17c3.4 0 3.825-.141 5.1-.141 1.275 0 1.983-.284 2.408-.425.567-.284.992-.567 1.417-.992.425-.425.708-.85.992-1.417.141-.425.425-1.133.425-2.408.123-1.11.139-1.576.141-3.924V17c0-3.4-.141-3.825-.141-5.1 0-1.275-.284-1.983-.425-2.408-.284-.567-.567-.992-.992-1.417-.425-.425-.85-.708-1.417-.992-.425-.141-1.133-.425-2.408-.425-1.11-.123-1.576-.139-3.924-.141zM17 10.483c3.683 0 6.517 2.975 6.517 6.517 0 3.542-2.975 6.517-6.517 6.517-3.542 0-6.517-2.834-6.517-6.517 0-3.683 2.975-6.517 6.517-6.517zm0 2.267c-2.408 0-4.25 1.842-4.25 4.25s1.842 4.25 4.25 4.25 4.25-1.842 4.25-4.25-1.842-4.25-4.25-4.25zm6.8-4.108c.86 0 1.558.697 1.558 1.558 0 .86-.697 1.558-1.558 1.558-.86 0-1.558-.697-1.558-1.558 0-.86.697-1.558 1.558-1.558z" transform="translate(-4 -4)"/>
                  </g>
                </svg>
                <svg xmlns="http://www.w3.org/2000/svg" width="26" height="19" viewBox="0 0 26 19">
                  <g fill="none" fill-rule="evenodd">
                    <path d="M0 0H34V34H0z" transform="translate(-4 -8)"/>
                    <path fill="#f6b92f" d="M29.183 11.05c-.283-1.133-1.133-1.983-2.266-2.267C24.933 8.217 17 8.217 17 8.217s-7.933 0-9.917.566C5.95 9.067 5.1 10.058 4.817 11.05c-.567 2.125-.567 6.233-.567 6.233s0 4.109.567 6.234c.283.991 1.133 1.983 2.266 2.266 1.984.567 9.917.567 9.917.567s7.933 0 9.917-.567c1.133-.283 1.983-1.133 2.266-2.266.567-2.125.567-6.234.567-6.234s0-4.108-.567-6.233zM14.45 21.108v-7.65l6.658 3.825-6.658 3.825z" transform="translate(-4 -8)"/>
                  </g>
                </svg>

              </div>
            </section>
            <section class="se-tiver-duvidas">
              <h4>Se tiver alguma duvida ou sugestao</h4>
              <li><router-link :to="{name: ''}">245 000 000</router-link><span>ou</span><router-link :to="{name: ''}">mail@ohelvas.pt</router-link></li>
            </section>
            <section class="mudar-idioma">
              <h4>MUDAR IDIOMA</h4>
              <section>
                <a>Português</a>
                <a>Francês</a>
                <a>Inglês</a>
              </section>
            </section>
          </div>
        </ol>
      </div>
    </section>
    <img class="icon open-icon" :class="{'close': this.open}" @click="toggleMenu()" src="@/assets/menu-hamburger.svg">
    <img class="icon close-icon" :class="{'open': this.open}" @click="toggleMenu()" src="@/assets/menu-close.svg">
  </div>
</template>
<script>
import ElvasButton from './elvas-button.vue'

export default {
  name: 'menu',
  components: {
    ElvasButton
  },
  data() {
    return {
      open: false
    }
  },
  mounted () {
  },
  methods: {
    toggleMenu () {
      this.open = !this.open
    }
  },
  watch: {
    $route () {
      this.open = false
    }
  }
}
</script>
<style lang="scss" scoped>
.menu {
  .exterior {
    height: 100vh;
    width: 100vw;
  }
  .interior {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    background: #a79374;
    color: white;
    z-index: 100;
    display: none;
    &.open {
      display: flex;
      .main-links {
        transform: unset;
      }

    }
    & > .links-wrapper  {
      display: flex;
      width: 100%;
      .main-links {
        position: relative;
        height: 100%;
        overflow: hidden;
        width: 60%;
        z-index: 1;
        display: flex;
        .background-filter {
          z-index: 1;
          position: absolute;
          height: 100%;
          width: 100%;
          top: 0;
          left: 0;
        }
      }
      .links {
        display: table;
        margin: auto 0 auto 0;
        transition: all 1s;
        li {
          z-index: 2;
          position: relative;
          margin: 20px 0;
          margin-left: 80px;
          font-size: 44px;
          text-transform: uppercase;
          font-weight: bold;
          line-height: 1.14;
          letter-spacing: -0.46px;
          padding-bottom: 5px;
          display: table;
          &:first-of-type {
            margin-top: 0;
          }
          &:last-of-type {
            margin-bottom: 0;
          }
        }
        .small-links {
          margin-top: 48px;
          li {
            margin-left: 0;
            text-transform: capitalize;
            font-size: 24px;
          }
        }
      }
      .sub-links {
        width: 40%;
        display: flex;
        flex-direction: column;
        background: #e4e6ea;
        color: #a79374;
        .login-register {
          margin-bottom: 40px;
          div {
            display: flex;
            a:nth-of-type(2) {
              margin-left: 16px;
            }
          }
        }
        a {
          font-family: 'Sen';
          color: #f6b92f;
          font-size: 24px;
          font-weight: bold;
          opacity: 1;
          &:hover {
            color: #d39e27;
          }
        }
        h4 {
          font-size: 24px;
          font-weight: 500;
          text-transform: uppercase;
          margin-bottom: 20px;
          letter-spacing: 0.6px;
          font-family: 'Barlow Condensed';
        }
        .siga-nos {
          margin-bottom: 40px;
          div {
            display: flex;
            align-items: center;
            svg:nth-of-type(2) {
              margin: 0 16px;
            }
          }
        }
        .se-tiver-duvidas {
          margin-bottom: 80px;
          li {
            margin: 24px 0;
            font-family: 'Barlow Condensed';
          }
          span {
            margin: 0 8px;
          }
        }
        .se-tiver-duvidas {
          margin-top: auto;
        }
        .mudar-idioma section {
          display: flex;
          a {
            margin: 0 8px;
          }
        }
        & > div {
          display: table;
          margin: auto 85px;
        }
      }
    }
    a {
      opacity: 0.5;
      color: white;
      text-decoration: none;
      &:hover {
        opacity: 1;
      }
      &.router-link-exact-active {
        opacity: 1;
      }
    }

    @media (max-width: 1110px) {
      .links-wrapper  {
        .main-links {
          width: 55%;
        }
        .sub-links {
          width: 45%;
        }
      }
    }
    @media (max-width: 950px) {
      .links-wrapper {
        overflow-y: auto;
        flex-direction: column;
        min-height: 100vh;

        .main-links {
          padding: 16px;
          width: calc(100% - 32px);
          flex-direction: column;
          min-height: 550px;

          .links li {
            font-size: 32px;
            margin-left: 0;
            width: 100vw;
          }

          ol:last-child li{
            font-family: Sen;
            font-size: 24px;
            font-weight: bold;
            line-height: 1.25;
            color: #ffffff;
            opacity: 0.5;
            margin-bottom: 16px;
          }
        }
        .sub-links {
          width: calc(100% - 64px);
          padding: 64px 32px;

          div {
            overflow: hidden;
            margin: 0;

          }
        }
      }
    }
  }
  img.icon {
    position: absolute;
    top: 35px;
    right: 35px;
    cursor: pointer;
    &.open-icon {
      z-index: 200;
      right: 16px;
      top: 16px;
      &.close {
        display: none;
      }
    }
    &.close-icon {
      position: fixed;
      z-index: 200;
      right: 16px;
      top: 16px;
      display: none;
      &.open {
        display: block;
      }
    }
  }
}
</style>